import {Injectable}  from '@angular/core';
import {IGridData}   from '../ap-interface';
import {StatusClass} from '../types/common-types';
import IField = Data.FieldManagement.IField;
import IGuid = System.IGuid;
import IFieldGeom = Data.FieldManagement.IFieldGeom;

export interface IFieldGridData extends IGridData<IField> {
  Id: IGuid;
  SourceItem: IField;
  Geom: IFieldGeom;
  LandUse: string;
  Area: number;
  AreaOriginal: string;
  MainCrop: string;
  SecondCrop: string;
  Note: string;
  MainCropExpectedYield: string;
  SecondCropExpectedYield: string;
  StrawHarvested: boolean;
  StatusClass: StatusClass;
  Status: number;
  StatusDesc: string;
  PackageId: IGuid;
}

@Injectable({
  providedIn: 'root'
})
export class FieldGridDataFactoryService {
  constructor() {
  }

  CreateNew(sourceItem: IField, templateObject?: any): IFieldGridData {
    const newField: IFieldGridData = {
      Id: null,
      SourceItem: sourceItem,
      Geom: sourceItem.DefaultGeom,
      LandUse: '',
      Area: 0,
      AreaOriginal: '',
      MainCrop: '',
      SecondCrop: '',
      Note: '',
      MainCropExpectedYield: '',
      SecondCropExpectedYield: '',
      StrawHarvested: false,
      StatusClass: null,
      Status: 0,
      StatusDesc: '',
      PackageId: null,
    };

    Object.keys(templateObject).map(prop => {
      if (newField.hasOwnProperty(prop)) {
        newField[prop] = templateObject[prop];
      } else {
        console.warn('There is no property ' + prop + ' in IField interface. Please check your input parameter.');
      }
    });

    return newField;
  }
}
